module.exports = __webpack_public_path__ + "static/media/menu.132423f3.png";